export function formatRelativeDate(iso: string): string {
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) return 'Hoje';
  if (diffDays === 1) return 'Ontem';
  if (diffDays < 30) return `Há ${diffDays} dias`;

  if (diffDays < 365) {
    const months = Math.floor(diffDays / 30);
    return `Há ${months} ${months === 1 ? 'mês' : 'meses'}`;
  }

  const years = Math.floor(diffDays / 365);
  return `Há ${years} ${years === 1 ? 'ano' : 'anos'}`;
}
